// export const BASE_URL: string = "http://127.0.0.1:8000/api";

export const BASE_URL: string = process.env.NODE_ENV === 'development' ? 'http://192.168.0.4:8000/api' : 'https://malek-store.ly/api';
// export const BASE_URL: string = process.env.NODE_ENV === 'development' ? 'http://192.168.0.5:8000/api' : 'https://malek-store.ly/api';

// reCAPTCHA v3 site key. The backend must verify with the *v3 secret paired
// with this key* (RECAPTCHA_SECRET_KEY) — pairing it with a v2 secret makes
// every form 401. Override per environment with REACT_APP_RECAPTCHA_SITE_KEY.
const DEFAULT_RECAPTCHA_SITE_KEY: string = process.env.NODE_ENV === 'development'
    ? '6LeAZ6IpAAAAAFt1Ln6qQwWkbVZhYjh9AeY5gXVu'
    : '6Lcr9f0pAAAAAK1RxHWtyA3cyEnyMiPTubR7l1jw';

export const RECAPTCHA_PUBLIC_KEY: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || DEFAULT_RECAPTCHA_SITE_KEY;

export const DEFAULT_EMAIL: string = "info@malek-store.ly"

// Mobile app store listings for the "get the app" modal. A platform with no URL
// simply drops its button, and the modal stays hidden when neither is set — so
// an unconfigured build never shows a dead end. Override per environment with
// REACT_APP_ANDROID_APP_URL / REACT_APP_IOS_APP_URL.
//
// Keep the verified public store URLs as fallbacks. Environment variables can
// still override them for a staging or replacement listing, but production
// builds must not silently omit either download button when no env file is
// deployed alongside the frontend.
export const ANDROID_APP_URL: string = process.env.REACT_APP_ANDROID_APP_URL
    || "https://play.google.com/store/apps/details?id=ly.malekstore.app";
export const IOS_APP_URL: string = process.env.REACT_APP_IOS_APP_URL
    || "https://apps.apple.com/us/app/malek-store/id6745765688";

// How long a choice ("continue on the site", or a store visit) is respected
// before the modal is offered again.
export const APP_PROMO_SNOOZE_DAYS: number = 30;
